import { token } from '@/infrastructure/container';

// The retry backoff, injected so a test observes attempt count and key reuse instead of waiting
// out 80-300ms of jitter per attempt (docs/sync.md). A store that reached for setTimeout directly
// would be a store whose retry ladder can only be verified by a suite that sleeps.

export interface ISleeper {
  sleep(ms: number): Promise<void>;
}

export const TOKEN_ISleeper = token<ISleeper>('ISleeper');

export class TimerSleeper implements ISleeper {
  sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
